
const stickyCart = document.querySelector('.sticky-cart-wrapper');
const isMinimal = window.location.pathname.includes('/pages/microshots-minimal') || window.location.pathname.includes('/pages/microshots-minimal-intent');

if (stickyCart) {
  // Function to handle scroll and visibility of the sticky cart
  function onScroll() {

    if (isMinimal) {
      if (window.scrollY > 250) {
      setTimeout(() => {
        stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute to show the sticky cart
      }, 50);
      } else {
        setTimeout(() => {
        stickyCart.removeAttribute('animate');  // Remove the 'animate' attribute to hide the sticky cart
      }, 50);
      }
    }

    if (!isMinimal) {
      if (window.scrollY > 0) {
      setTimeout(() => {
        stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute to show the sticky cart
        console.log('Animate attribute added on scroll');
      }, 50);
      } else {
        setTimeout(() => {
        stickyCart.removeAttribute('animate');  // Remove the 'animate' attribute to hide the sticky cart
        console.log('Animate attribute removed on scroll');
      }, 50);
      }
    }
  }

  // Run the function once on page load to show the sticky cart
   if (!isMinimal) {
    window.addEventListener('load', () => {
      stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute on page load
      console.log('Animate attribute added on page load');
    });
   }

  // Add scroll event listener to handle scroll events
  window.addEventListener('scroll', onScroll);
}





  // const stickyCart = document.querySelector('.sticky-cart-wrapper');
  // const isMinimalPage = window.location.pathname.includes('/pages/microshots-minimal');

  // console.log('Sticky cart JS running');
  // console.log('Is minimal page:', isMinimalPage);
  // console.log('Current scrollY:', window.scrollY);
  // console.log('Sticky cart found:', !!stickyCart);

  // if (!stickyCart) return; // Stop if sticky cart doesn't exist

  // function onScroll() {
  //   const scrollY = window.scrollY;
  //   console.log('ScrollY position:', scrollY);

  //   if (isMinimalPage) {
  //     if (scrollY > 287) {
  //       stickyCart.setAttribute('animate', '');
  //       console.log('Sticky cart animated after scroll on custom page');
  //     } else {
  //       stickyCart.removeAttribute('animate');
  //       console.log('Sticky cart hidden before scroll threshold on custom page');
  //     }
  //   } else {
  //     if (window.scrollY > 0) {  // If there's any scroll position (i.e., scroll has started)
  //     setTimeout(() => {
  //       stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute to show the sticky cart
  //       console.log('Animate attribute added on scroll');
  //     }, 50);
  //   } else {
  //     setTimeout(() => {
  //       // stickyCart.removeAttribute('animate');  // Remove the 'animate' attribute to hide the sticky cart
  //       console.log('Animate attribute removed on scroll');
  //     }, 50);
  //   }
  // }

  // // Run once on load
  // onScroll();

  // // Run on scroll
  // window.addEventListener('scroll', onScroll);





// if (stickyCart) {
//   function onScroll() {
//     // Check if the user is scrolling
//     if (window.scrollY > 0) {  // If there's any scroll position (i.e., scroll has started)
//       setTimeout(() => {
//         stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute to show the sticky cart
//         console.log('Animate attribute added');
//       }, 50);
//     } else {
//       setTimeout(() => {
//         stickyCart.removeAttribute('animate');  // Remove the 'animate' attribute to hide the sticky cart
//         console.log('Animate attribute removed');
//       }, 50);
//     }
//   }
  
//   // Add scroll event listener
//   window.addEventListener('scroll', onScroll);
  
//   // Run the function once on page load to check the initial scroll state
//   onScroll();
// }

